// revendas-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Agência": "Agencia",
    "Anexar contrato": "Adjuntar contrato",
    "CPF/CNPJ": "CPF/CNPJ",
    "Chave Pix": "Clave Pix",
    "Conta": "Cuenta",
    "Contrato": "Contrato",
    "Dados": "Datos",
    "Dados Bancários": "Datos Bancarios",
    "Dia de Pagamento": "Día de Pago",
    "Editar revenda": "Editar revendedor",
    "Fixada": "Fija",
    "Física": "Física",
    "Inscrição Municipal": "Inscripción Municipal",
    "Jurídica": "Jurídica",
    "Nome Fantasia": "Nombre Fantasía",
    "Nova revenda": "Nuevo revendedor",
    "Razão Social": "Razón Social",
    "Telefone Fixo": "Teléfono Fijo",
    "Tipo de comissão": "Tipo de comisión",
    "Valor da comissão": "Valor de la comisión",
    "Vencimento do contrato": "Vencimiento del contrato",
    "contato": "contacto",
};

export default catalogo;
